import { FC, ReactNode } from 'react';
import {
  Button as PrimeReactButton,
  ButtonProps as PrimeReactButtonProps,
} from 'primereact/button';
import { classNames } from 'primereact/utils';
import styles from './Button.module.scss';

interface ButtonProps extends PrimeReactButtonProps {
  className?: string;
  children?: ReactNode;
  secondary?: boolean;
  text?: boolean;
  green?: boolean;
}

const Button: FC<ButtonProps> = ({
  className,
  children,
  secondary,
  green,
  ...rest
}) => {
  return (
    <PrimeReactButton
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      className={classNames(
        styles.button,
        className,
        secondary && styles.secondary,
        green && styles.green
      )}
    >
      {children}
    </PrimeReactButton>
  );
};

export default Button;
